import gql from 'graphql-tag';
import { UrlAliasAllData } from '../fragments';

export default gql`
query getUrlAlias($source_url: String) {
    getUrlAlias(source_url: $source_url) {
        ...UrlAliasAllData
    }
}
${UrlAliasAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/getUrlAlias.ts